import { useState, useRef } from "react";
import { Building2, Upload } from "lucide-react";
import { Modal, FormField, Input, Button } from "../ui/index";
import PhoneInput from "../ui/PhoneInput";

export default function AddRevendeurModal({ isOpen, onClose, onAdd }) {
  const [form, setForm] = useState({
    nom: "", responsable: "", email: "", adresse: ""
  });
  const [telephones, setTelephones] = useState([""]);
  const [logo, setLogo] = useState(null);
  const fileRef = useRef();

  const handleChange = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleLogo = (e) => {
    const file = e.target.files[0];
    if (file) setLogo(URL.createObjectURL(file));
  };

  const handleSubmit = () => {
    if (!form.nom || !form.responsable || !form.email) return;
    onAdd?.({ ...form, telephones, logo });
    setForm({ nom: "", responsable: "", email: "", adresse: "" });
    setTelephones([""]);
    setLogo(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Ajouter un revendeur" subtitle="Créez un nouveau revendeur partenaire dans le système.">
      <div className="space-y-4">

        {/* Logo upload */}
        <div className="flex items-center gap-3">
          <div className="w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden border border-gray-200">
            {logo
              ? <img src={logo} alt="logo" className="w-full h-full object-cover" />
              : <Building2 size={28} className="text-gray-400" />
            }
          </div>
          <button
            onClick={() => fileRef.current.click()}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 border border-gray-200 rounded-xl text-sm text-slate-600 hover:bg-gray-50 transition-colors"
          >
            <Upload size={16} className="text-slate-400" />
            Télécharger un logo
          </button>
          <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handleLogo} />
        </div>

        {/* Nom commercial */}
        <FormField label="Nom commercial de l'entreprise" required>
          <Input value={form.nom} onChange={handleChange("nom")} placeholder="Nom commercial de l'entreprise" />
        </FormField>

        {/* Responsable */}
        <FormField label="Responsable" required>
          <Input value={form.responsable} onChange={handleChange("responsable")} placeholder="Nom du représentant" />
        </FormField>

        {/* Email */}
        <FormField label="Email de contact" required>
          <Input value={form.email} onChange={handleChange("email")} placeholder="exemple@gmail.com" type="email" />
        </FormField>

        {/* Téléphones */}
        <FormField label="Téléphone(s)" required>
          <PhoneInput value={telephones} onChange={setTelephones} />
        </FormField>

        {/* Adresse */}
        <FormField label="Adresse">
          <Input value={form.adresse} onChange={handleChange("adresse")} placeholder="Adresse complète" />
        </FormField>

        {/* Boutons */}
        <div className="flex justify-end gap-3 pt-2">
          <Button variant="secondary" onClick={onClose}>Annuler</Button>
          <Button onClick={handleSubmit}>Ajouter</Button>
        </div>
      </div>
    </Modal>
  );
}